import { render, staticRenderFns } from "./DataSets.vue?vue&type=template&id=6ba89b50&"
import script from "./DataSets.vue?vue&type=script&lang=js&"
export * from "./DataSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports